import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Strips the leftover signup jwt query param before entering the chat llm board/widget
 */
export const chatGuard: CanActivateFn = (next, state) => {
  const router = inject(Router);

  if (state.root.queryParams.jwt) {
    router.navigate([state.url.split('?')[0]], {
      queryParams: Object.assign({}, state.root.queryParams, {
        jwt: null,
      }),
      queryParamsHandling: 'merge',
    });
  }
  return true;
};
